import { render, staticRenderFns } from "./solmar-villas.vue?vue&type=template&id=294fb6ec&scoped=true"
import script from "./solmar-villas.vue?vue&type=script&lang=js"
export * from "./solmar-villas.vue?vue&type=script&lang=js"
import style0 from "./solmar-villas.vue?vue&type=style&index=0&id=294fb6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294fb6ec",
  null
  
)

export default component.exports